<template>
    <div>
        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox">
            <div class="item" v-for="(picture, index) in pictures" :class="{active: index === 0}">
                <img :src="image(picture)">
                <div class="carousel-caption">
                    {{$t(picture.caption)}}
                </div>
            </div>
        </div>

        <!-- Indicators -->
        <ol class="carousel-indicators">
            <li data-target="#carousel" v-for="(picture, index) in pictures" :data-slide-to="index" :class="{active: index == 0}"></li>
        </ol>

        <!-- Controls -->
        <a class="left carousel-control" href="#carousel" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" href="#carousel" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</template>

<script>
let images = require.context("../../assets/img/big", false, /\.jpg$/);

export default {
  name: "slider",
  methods: {
    image: function(image) {
      return images("./" + image.path + ".jpg");
    }
  },
  data: function() {
    return {
      pictures: [
        {
          path: "Bethlehem",
          caption: "slider.Betlehem"
        },
        {
          path: "VergissEsNie2",
          caption: "slider.VergissEsNie"
        },
        {
          path: "SchnippSchnapp",
          caption: "slider.SchnippSchnapp"
        },
        {
          path: "DrehDieZeit",
          caption: "slider.DrehDieZeit"
        },
        {
          path: "JetztOeffneIchDieTuerVorMir",
          caption: "slider.JetztOeffneIch"
        },
        {
          path: "WasFuerEinFreudentag",
          caption: "slider.WasFuerEinFreudentag"
        },
        {
          path: "Ruth-IchhabeeinenPlan",
          caption: "slider.IchhabeeinenPlan"
        },
        {
          path: "PloniMaloni",
          caption: "slider.PloniMaloni"
        },
        {
          path: "AdonaiRoi",
          caption: "slider.AdonaiRoi"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

.carousel {
  margin-bottom: 40px;

  .carousel-indicators {
    bottom: -40px;

    @include media-phone {
      display: none;
    }

    li {
      margin-right: 5px;
    }
  }

  .carousel-caption {
    padding: 5px 50px;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    right: 0;
    left: 0;

    @include media-phone {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/Slider.vue